import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  FederalLotteriesContestData,
  FederalLotteriesContestResponse,
} from '@/features/federalLotteries/types/federalLottery.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useFederalLottery: (id: string) => UseQueryResult<FederalLotteriesContestData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<FederalLotteriesContestResponse, unknown, FederalLotteriesContestData>({
    queryKey: ['federalLotteriesContest', id],
    queryFn: () => {
      return privateAxios.get(`/tmais/federal_lotteries/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
